import Env from "../base/env";
import Component from "gia/Component";
import { CharHoverSlide } from "./Common";
import gsap from "gsap";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    if (Env.mobileCSS == false) {
      gsap.delayedCall(0.1, () => CharHoverSlide(this.DOM.view));
    }
  }
}
